import { atom } from 'jotai';

export enum CurrentQuizEditorDialog {
  None = 'None',
  Paywall = 'Paywall',
  UnsavedChanges = 'UnsavedChanges',
  DeleteEmptyQuiz = 'DeleteEmptyQuiz',
  GenerateQuestions = 'GenerateQuestions',
  ImportFromText = 'ImportFromText',
}

export const currentQuizEditorDialogAtom = atom<CurrentQuizEditorDialog>(
  CurrentQuizEditorDialog.None
);
